export default __webpack_public_path__ + "static/media/AKM_7.af1a0d7c.png";